import * as React from 'react';
import { NASStatus } from '@websky/graphql';
import EveryPortCard from '../../../../../EveryPortCard/EveryPortCard/EveryPortCard';
import EveryPortTraveller from './EveryPortTraveller/EveryPortTraveller';
import { useTheme } from '../../../../../theme';
import { PassengerType } from '../../../../../enums';
import { useTranslation } from 'react-i18next';
const SelectedService = ({ service, onCancel, travellers, selectedTravellersInSegment, removeTraveller, addTraveller, modifyAvailable }) => {
    const theme = useTheme('CheckoutAdditionalService').EveryPortLounge;
    const { t } = useTranslation('ServiceAggregation');
    const travellerOptions = React.useMemo(() => {
        const travellersArray = [];
        service.fares.forEach(fare => {
            fare.prices.forEach(priceItem => {
                const travellerFromState = selectedTravellersInSegment.find(item => item.travellerId === priceItem.traveller.id && item.product.id === service.id);
                travellersArray.push({
                    traveller: travellers.find(traveller => traveller.id === priceItem.traveller.id),
                    fare: fare,
                    price: priceItem.price,
                    active: !!travellerFromState,
                    confirmed: !!travellerFromState && (travellerFromState === null || travellerFromState === void 0 ? void 0 : travellerFromState.status) !== NASStatus.New,
                    disabled: !travellerFromState && !modifyAvailable
                });
            });
        });
        return travellersArray.sort(({ confirmed: a }, { confirmed: b }) => +a - +b);
    }, [service, selectedTravellersInSegment, modifyAvailable]);
    const noAdultsInSelectedTravellers = React.useMemo(() => {
        const activeItems = travellerOptions.filter(traveller => traveller.active);
        if (activeItems.length > 0) {
            return activeItems.every(traveller => traveller.traveller.type !== PassengerType.Adult);
        }
        return false;
    }, [travellerOptions]);
    const allAdultsPassengerSelected = React.useMemo(() => {
        return travellerOptions.every(traveller => traveller.traveller.type !== PassengerType.Adult || traveller.active);
    }, [travellerOptions]);
    React.useEffect(() => {
        if (allAdultsPassengerSelected) {
            travellerOptions
                .filter(traveller => traveller.traveller.type !== PassengerType.Adult)
                .forEach(traveller => {
                addTraveller(traveller.traveller.id, service, traveller.fare);
            });
        }
    }, [allAdultsPassengerSelected, service]);
    return (React.createElement(React.Fragment, null,
        React.createElement(EveryPortCard, { key: service.id, options: service.facilities, terminalName: service.terminalName, price: service.price, images: service.images, name: service.name, description: service.description, location: service.meetingPoint, isSelected: true, onSelect: modifyAvailable ? onCancel : null, category: service.category }),
        React.createElement("div", { className: theme.travellers }, travellerOptions
            .filter(traveller => !traveller.disabled)
            .map((traveller, index) => (React.createElement(EveryPortTraveller, { tooltipText: noAdultsInSelectedTravellers && index === 0
                ? t('Please choose at least one adult traveller')
                : null, isSelected: traveller.active, key: traveller.traveller.id, traveller: traveller.traveller, price: traveller.price, isConfirmed: traveller.confirmed, disabled: traveller.traveller.type !== PassengerType.Adult && allAdultsPassengerSelected, onClick: () => {
                if (traveller.active) {
                    removeTraveller(traveller.traveller.id, service, traveller.fare);
                }
                else {
                    addTraveller(traveller.traveller.id, service, traveller.fare);
                }
            } }))))));
};
export default SelectedService;
